import { render, staticRenderFns } from "./mediaForm.vue?vue&type=template&id=61322324&scoped=true"
import script from "./mediaForm.vue?vue&type=script&lang=js"
export * from "./mediaForm.vue?vue&type=script&lang=js"
import style0 from "./mediaForm.vue?vue&type=style&index=0&id=61322324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61322324",
  null
  
)

export default component.exports